import { ModelViewerLocation } from './model-viewer-location.dto';
import { DermloopClinicalActionTypeEnum } from '@dermloop/static-values';
import { Expose, Transform } from 'class-transformer';
import {
  IsBoolean,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';

export class ClinicalAssessmentQueryResult {
  @Expose()
  @IsString()
  @IsNotEmpty()
  condition_id: string;

  /** @deprecated Use condition_id */
  @Expose()
  @IsOptional()
  @IsString()
  lesion_id?: string;

  @Expose()
  @IsOptional()
  @IsEnum(DermloopClinicalActionTypeEnum)
  condition_triage_action: DermloopClinicalActionTypeEnum;

  /** @deprecated Use condition_triage_action */
  @Expose()
  @IsOptional()
  @IsEnum(DermloopClinicalActionTypeEnum)
  lesion_triage_action: DermloopClinicalActionTypeEnum;

  @Expose()
  @IsOptional()
  @ValidateNested()
  @Transform(({ value }) =>
    typeof value === 'string' ? JSON.parse(value) : value,
  )
  precise_location?: ModelViewerLocation;

  @Expose()
  @IsOptional()
  @IsString()
  gender?: string;

  @Expose()
  @IsOptional()
  @IsString()
  ssn?: string;

  @Expose()
  @IsString()
  @IsUUID('all')
  triage_id: string;

  @Expose()
  @IsNotEmpty()
  @IsUUID('all')
  triage_created_by_user_id: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toISOString())
  triage_created?: string;

  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toISOString())
  triage_updated?: string;

  @Expose()
  @IsOptional()
  @IsUUID('all')
  assessment_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_type?: 'pathology' | 'tele';

  @Expose()
  @IsOptional()
  @IsUUID('all')
  assessment_diagnosis_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_diagnosis_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_diagnosis_legacy_identifier?: string;

  @Expose()
  @IsOptional()
  @IsUUID('all')
  assessment_secondary_diagnosis_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_secondary_diagnosis_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_secondary_diagnosis_legacy_identifier?: string;

  @Expose()
  @IsOptional()
  @IsUUID('all')
  assessment_tertiary_diagnosis_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_tertiary_diagnosis_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_tertiary_diagnosis_legacy_identifier?: string;

  @Expose()
  @IsOptional()
  @IsString()
  assessment_proposed_clinical_action?: string;

  @Expose()
  @IsOptional()
  @IsUUID('all')
  latest_diagnosis_group_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_diagnosis_group_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_diagnosis_group_article_id?: string;

  @Expose()
  @IsOptional()
  @IsUUID('all')
  latest_diagnosis_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_diagnosis_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_diagnosis_legacy_identifier?: string;

  @Expose()
  @IsOptional()
  @IsUUID('all')
  latest_differential_diagnosis_group_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_differential_diagnosis_group_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_differential_diagnosis_group_article_id?: string;

  @Expose()
  @IsOptional()
  @IsUUID('all')
  latest_differential_diagnosis_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_differential_diagnosis_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  latest_differential_diagnosis_legacy_identifier?: string;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  correct_diagnosis?: boolean;

  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toString())
  latest_action?: string;

  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toString())
  latest_action_details?: string;

  @Expose()
  @IsNotEmpty()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toString())
  user_dermoscopic_image_id?: string;

  @Expose()
  @IsNumber()
  @IsOptional()
  user_focal_point_x?: number;

  @Expose()
  @IsNumber()
  @IsOptional()
  user_focal_point_y?: number;

  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toString())
  user_image_medical_unit_id?: string;

  @Expose()
  @IsNotEmpty()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toString())
  latest_dermoscopic_image_id?: string;

  @Expose()
  @IsNumber()
  @IsOptional()
  latest_focal_point_x?: number;

  @Expose()
  @IsNumber()
  @IsOptional()
  latest_focal_point_y?: number;

  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toString())
  latest_image_medical_unit_id?: string;
}
